<template>
  <div :class="classname">

    <el-input
        v-show="searchable==='true'"
        ref="recherche"
        :placeholder="recherche"
        v-model="filterText"
        class="rechercher"
        clearable
        @clear="reset"
        @keyup.erase-eof="reset"
    ></el-input>
    <el-tree
        v-slot="{node,data}"
        :data="data"
        :props="defaultProps"
        node-key="filterValue"
        :filter-node-method="filterNode"
        @node-click="handleNodeClick"
        class="wxmElTree-habillage filter-tree"
        :expand-on-click-node="false"
        :default-expanded-keys="ArrayCurrentKey"
        :ref="parent_field"
        highlight-current
        :empty-text="emptyCaption"
        @mouseover.native="expand($event)"
        @mouseleave.native="collapse($event)"
    >
      <div class="test" :title="node.label">
        <a
            href="#"
            class="arbre"
            :filterValue="data.filterValue"
        >
          <span :class="icon" style="width: 10px" aria-hidden="true"></span>
          <span class="nomLabel " :filterValue="data.filterValue">{{ node.label }}</span>
          <span class="cardinalite">{{ data.count }}</span>
        </a>
      </div>
    </el-tree>
  </div>
</template>

<script>
export default {
  name: "wxm-el-tree",

  props: {

    icon: {
      type: String,
      default: ""
    },
    load: String,
    rel_field: String,
    recherche: String,
    empty: String,
    child_object: String,
    parent_field: String,
    parent_object: String,
    filter_op: String,
    count: String,
    filter_unused: String,
    form_action: String,
    activate_base_edit_list: String,
    wedialink_contextualize: String,
    folderable: Boolean,
    classname: String,
    searchable: {
      type: String,
      default: "true"
    }
  },
  created() {
    //On rend draggable les ?l?ments de liste
    var self = this;
    var draggable = $("div.articleBox, div.tableDatalist table tr");
    draggable.draggable({
      helper: self.helper,
      cursorAt: {top: -15, left: -15},
      revert: "invalid",

      drag: function (event, ui) {
        if (event.originalEvent.target.previousElementSibling) {
          if (event.originalEvent.target.previousElementSibling.classList.contains("fa-folder")) {
            ui.helper[0].style.border = null
          } else {
            ui.helper[0].style.border = "3px solid red"
          }
        }
      }
    });
    $.ajax({
      type: "GET",
      dataType: "json",
      url: boState.getContextPath() + self.load,
      data: {
        rel_field: self.rel_field,
        child_object: self.child_object,
        parent_field: self.parent_field,
        parent_object: self.parent_object,
        filter_op: self.filter_op,
        count: self.count,
        filterUnused: self.filter_unused,
        form_action: self.form_action,
        activate_base_edit_list: self.activate_base_edit_list,
        wedialink_contextualize: self.wedialink_contextualize
      },
      success: function (data) {
        self.data = data.datas ? data.datas.children : data.children;
        self.setCounts(self.data);
        self.filterField = data.datas ? data.datas.filterField : data.filterField;
        self.ArrayCurrentKey = [localStorage["currentKey".concat(self.filterField)]]
        self.emptyCaption = self.empty;
      }
    });
  },
  data: function () {
    return {
      emptyCaption: boi18n.getMessage(
          "/bov3/wcm",
          "searchtree_loading"
      ),
      currentKey: "",
      filterText: "",
      data: [],
      filterField: "",
      ArrayCurrentKey: [],
      defaultProps: {
        children: "children",
        label: "title"
      },
      currentExpanded: [],
      expandable: false
    };
  }
  ,
  watch: {
    /**Filtrer les noeuds � l'aide du champ recherche sans tenir compte des MAJS ni de la casse */
    filterText(val, event) {
      var v = this;
      setTimeout(function () {
        var tree = v.parent_field;
        v.$refs[tree].filter(val.replace(/[\u0300-\u036f]/g, "").toUpperCase());
      }, 800);
    }
  },
  updated() {
    /*A chaque instanciation de la vue, on r�cup�re le noeud cliqu� auparavant ( gr�ce au cache), et on l'ouvre  */
    var tree = this.parent_field;
    this.ArrayCurrentKey.forEach(element =>
        this.$refs[tree].setCurrentKey(element)
    );
  },

  /* Drag and Drop avec jQuery UI car IE et Edge ne supporte pas HTML5 D&D => � modifier si changement*/
  mounted() {
    var self = this;
    var bundleName = "/bov3/wcm";
    var droppable = $(this.$el);
    if (self.folderable) {
      droppable.droppable({
        tolerance: "pointer",

        activate: function () {
          self.expandable = true;
        },
        deactivate: function () {
          self.expandable = false;
        },

        drop: function (event, ui) {
          var updateDatas = {
            objectType: self.parent_object,
            folderType: self.child_object,
            folderId: event.originalEvent.target.getAttribute("filterValue")
          };

          var pageSelection = wedia.bov3.Datalist.getCurrentPageSelection();
          if (pageSelection !== null && pageSelection.length > 0) {
            var completeSelection = wedia.bov3.Datalist.getCompleteSelection();
            if (completeSelection.length > pageSelection.length) {
              var question = boi18n.getMessage(
                  bundleName,
                  "bov3.datalist.folder.confirm_move_of_complete_selection"
              );
              updateDatas.objectIds = window.confirm(question)
                  ? completeSelection
                  : pageSelection;
            } else {
              updateDatas.objectIds = pageSelection;
            }
          } else {
            //On ne d?place que l'?lement "dragg?"
            updateDatas.objectIds = ui.draggable[0].getAttribute(
                "data-object-id"
            );
          }

          self.updateFolder(updateDatas);
        }
      });
    }
  },
  methods: {
    setCounts(data) {
      var self = this;
      data.forEach(element => {
        if (!element.count) {
          element.count = 0;
        }
        if (element.children.length > 0) {
          self.setCounts(element.children);
        }
      })
    },
    expand(event) {
      if (this.expandable) {
        var self = this;
        var tree = this.parent_field;
        var node = "";
        if (event.target.getAttribute("filterValue")) {
          node = self.$refs[tree].getNode(event.target.getAttribute("filterValue"))
          node.expanded = true
        }
        if (!self.currentExpanded.includes(node) && node != "") {
          self.currentExpanded.push(node);
        }
      }
    },
    collapse() {
      if (this.expandable) {
        var self = this;
        var tree = this.parent_field;
        if (self.currentExpanded.length > 0) {

          self.currentExpanded.forEach(node => {

            self.$refs[tree].getNode(node).expanded = false;
          })
        }
      }

    },
    reset: function () {
      document.querySelectorAll(".el-tree-node__children").forEach(element => {
        element.style.display = "none";
      });
      document
          .querySelectorAll("div.el-tree-node__content > span")
          .forEach(element => {
            element.classList.remove("expanded");
          });
    },

    /* Customisation de l'image dragu�e */
    helper() {
      var bundleName = "/bov3/wcm";
      //On va d'abord d?terminer combien nous avons d'?l?ments ? dragger.
      var selection = wedia.bov3.Datalist.getCurrentPageSelection();
      var count = selection && selection.length > 0 ? selection.length : 1; //L'?l?ment dragg?
      //On cr?e un helper correspondant ? ce compte.
      var helper =
          count == 1
              ? boi18n.getMessage(bundleName, "bov3.datalist.folder.single_helper")
              : boi18n.getMessage(
              bundleName,
              "bov3.datalist.folder.multiple_helper",
              count
              );
      var truc = $(
          "<div class='folderstree-ui-draggable-dragging fancytree-drag-helper'></div>"
      )
          .append(helper)
          .appendTo("body")
          .css({
            "z-index": 1000
          });
      return truc[0];
    },

    updateFolder(updateDatas) {
      $.ajax({
        url: "{0}/bov3/datalist/ajax/folders/updateFolder.jspz".format(
            boState.getContextPath()
        ),
        data: updateDatas,
        traditional: true,
        type: "POST",
        success: function () {
          //Si ca n'est pas le cas : ca n'est peut ?tre pas la peine de tout recharger.
          window.location.reload();
        }
      });
    },

    /**Fonction affichage des noeuds filtr�s */
    filterNode(value, data) {
      if (!value) return true;
      else {
        return (
            data.title
                .replace(/[\u0300-\u036f]/g, "")
                .toUpperCase()
                .indexOf(value) !== -1
        );
      }
    },
    /**Enregistrement cache noeud courant pour r�ouverture, ajout de filtre si le noeud est cliqu�, remove s'il a �t� d�ja cliqu� ,ajax pour appliquer l'�v�nement */
    handleNodeClick(data, node, tree) {
      var form,
          filterValue = data.filterValue;
      var cleCourante = node.key;
      var test = this.filterField;

      if (!localStorage[test] === "true") {
        localStorage[test] = true;
        localStorage["currentKey".concat(test)] = cleCourante;
        this.currentKey = cleCourante;
      } else {
        localStorage.removeItem(this.currentKey);
        localStorage[test] = true;
        localStorage["currentKey".concat(test)] = cleCourante;
        this.currentKey = cleCourante;
      }
      if (filterValue) {
        var filter = {
              field: this.filterField,
              op: this.filter_op,
              value: Array.of(data.filterValue)
            },
            form = {
              form_object: this.parent_object,
              action: data.selected === true ? "remove" : "add",
              filter: $.toJSON(filter)
            };
      } else {
        var filter = {
              field: this.filterField,
              op: this.filter_op
            },
            form = {
              form_object: this.parent_object,
              action: "del",
              filter: $.toJSON(filter)
            };
      }
      if (form.action === "remove") {
        localStorage.removeItem("currentKey".concat(test));
        localStorage[test] = false;
      }
      form.noredirect = "noredirect";

      $.ajax(
          boState.getContextPath() +
          "/bov3/datalist/content/search/ajax_init_search2.jspz",
          {
            type: "POST",
            data: form,
            traditional: true,
            success: function () {
              if (window._local_reload) {
                // d?finie par datalist.js et permet de r?-initialiser la pagination
                _local_reload(true);
              } else {
                window.location.reload();
              }
            }
          }
      );
    }
  }
};
</script>

<style lang="less" scoped>

.test {
  width: 100%;
}
</style>
